export default {
  cloudflare: {
    turnstile: {
      sitekey: process.env.VUE_APP_CLOUDFLARE_TURNSTILE_SITEKEY,
    },
  },
}
